import { Box, Grid } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../lib/hooks';
import { useEffect } from 'react';
import { setDocumentSearchType } from '../../lib/state/slices/ProjectStateSlice';
import { FilterFolders, FilterGraphViews } from '../../lib/SearchFilter';
import GraphItem from './GraphItem';

export default function GraphOverviewPage() {
  const searchQuery = useAppSelector((state) => state.viewReducer.documents.search.query.GRAPH);
  const graphs = useAppSelector((state) => state.viewReducer.documents.structure.GRAPH);

  const filteredGraphViews = FilterGraphViews(Object.values(graphs), searchQuery);
  return (
    <Box backgroundColor="background" p={2} height="100%">
      <Grid
        padding={4}
        style={{
          height: '100%',
          borderRadius: '10px',
          overflowY: 'auto',
          scrollbarWidth: 'thin',
          justifyItems: 'start',
        }}
        templateColumns={'repeat(auto-fit, minmax(380px, 1fr))'}
        gap={4}
      >
        {filteredGraphViews.map((graph) => (
          <GraphItem key={'graph' + graph.id} graph={graph} />
        ))}
      </Grid>
    </Box>
  );
}
